import { render, staticRenderFns } from "./aceitosCliente.vue?vue&type=template&id=7f5bd192&"
import script from "./aceitosCliente.vue?vue&type=script&lang=js&"
export * from "./aceitosCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports